import NProgress from '@/config/nprogress'
import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/login'
import { Dialog } from 'vant'
// 是否为移动端
// const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index.vue'),
      meta: {
        showNav: true
      }
    },
    {
      path: '/',
      redirect: '/dailyBackFour'
    },
    {
      path: '/dailyBackFour',
      name: '1',
      component: () => import('@/views/dailyBack/dailyBackFour'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/customLabel',
      name: '2',
      component: () => import('@/views/customLabel'),
      meta: {
        showNav: true
      }
    },
    {
      path: '/timeSeries',
      name: '3',
      component: () => import('@/views/timeSeries/timeSeries'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/administratorMain',
      name: '5',
      component: () => import('@/views/administrator/administratorMain'),
      meta: {
        showNav: true
      }
    },
    {
      path: '/userInfo',
      name: '6',
      component: () => import('@/views/user/userInfo'),
      meta: {
        showNav: true
      }
    },
    {
      path: '/policyLibrary',
      name: '7',
      component: () => import('@/views/strategyBase/policyLibrary'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/research',
      name: '8',
      component: () => import('@/views/research/research'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/notification',
      name: '9',
      component: () => import('@/views/notice/notification'),
      meta: {
        showNav: true
      }
    },
    {
      path: '/riskControlSystem',
      name: '10',
      component: () => import('@/views/risk/index.vue'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    // {
    //   path: '/gptLaboratory',
    //   redirect: '/gptLabEmpty'
    // },
    {
      path: '/gptLaboratory',
      name: '11',
      component: () => import('@/views/gptLab/gptLaboratory.vue'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/factorBase',
      name: '12',
      component: () => import('@/views/factorBase/index.vue'),
      meta: { showNav: true }
    },
    {
      path: '/newBuilt',
      name: 'newBuilt',
      component: () => import('@/views/timeSeries/newBuilt'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/strategyDetails',
      name: 'strategyDetails',
      meta: { showNav: true },
      component: () => import('@/views/strategyBase/strategyDetails')
    },
    {
      path: '/subscribeDetails',
      name: 'subscribeDetails',
      meta: { showNav: true },
      component: () => import('@/views/strategyBase/subscribeDetails')
    },
    {
      path: '/researchEditor',
      name: 'researchEditor',
      component: () => import('@/views/research/researchEditor'),
      meta: {
        keepAlive: true,
        showNav: true
      }
    },
    {
      path: '/researchDetails',
      name: 'researchDetails',
      meta: { showNav: true },
      component: () => import('@/views/research/researchDetails')
    },
    {
      path: '/infoCollector',
      name: '13',
      meta: { showNav: true },
      component: () => import('@/views/infoCollector/index.vue')
    },
    {
      path: '/infoCollector/list/detail',
      name: '13',
      meta: { showNav: true },
      component: () => import('@/views/infoCollector/index.vue')
    },
    {
      path: '/whiteList',
      name: 'WhiteList',
      meta: { showNav: false },
      redirect: '/whiteList/weChatMsgReply'
    },
    {
      path: '/whiteList/weChatMsgReply',
      name: 'WeChatMsgReply',
      meta: { showNav: false },
      component: () => import('@/views/whiteList/weChatMsgReply/index.vue')
    },
    {
      path: '/whiteList/weChatMsgReplyIDs',
      name: 'weChatMsgReplyIDs',
      meta: { showNav: false },
      component: () => import('@/views/whiteList/weChatMsgReply/MultipleIDs.vue')
    },
    {
      path: '/whiteList/morningNewsDetail',
      name: 'MorningNewsDetail',
      meta: { showNav: false },
      component: () => import('@/views/whiteList/weChatMsgReply/MorningNewsDetail.vue')
    },
    {
      path: '/whiteList/meetingList',
      name: 'MeetingList',
      meta: { showNav: false },
      component: () => import('@/views/whiteList/weChatMsgReply/MeetingList.vue')
    },
    {
      path: '/whiteList/mySubscribe',
      name: 'MySubscribe',
      meta: { showNav: false, title: '我的订阅' },
      component: () => import('@/views/whiteList/mySubscribe/index.vue')
    },
    {
      path: '/whiteList/mySubscribe/detail',
      name: 'MySubscribeDetail',
      meta: { showNav: false, title: '我的订阅详情' },
      component: () => import('@/views/whiteList/mySubscribe/detail.vue')
    },
    {
      path: '/whiteList/subscribe/reportLog',
      name: 'MySubscribeReport',
      meta: { showNav: false, title: '汇报详情页面' },
      component: () => import('@/views/whiteList/mySubscribe/reportLog.vue')
    },
    {
      path: '/whiteList/subscribe/reportLogDetail',
      name: 'MySubscribeReportDetail',
      meta: { showNav: false, title: '汇报记录详情页面' },
      component: () => import('@/views/whiteList/mySubscribe/reportLogDetail.vue')
    },
    {
      path: '/whiteList/infoCollector/list',
      name: 'WhiteListInfoCollectorList',
      meta: { showNav: false, title: '信息收集器-信息库' },
      component: () => import('@/views/whiteList/infoCollector/index.vue')
    },
    {
      path: '/whiteList/infoCollector/publicAccountList',
      name: 'WhiteListInfoCollectorPublicAccountList',
      meta: { showNav: false, title: '信息库-公众号列表' },
      component: () => import('@/views/whiteList/infoCollector/components/PublicAccountList.vue')
    },
    {
      path: '/whiteList/factorBase/share',
      name: 'WhiteListFactorBaseShare',
      meta: { showNav: false, title: '因子库-详情分享' },
      component: () => import('@/views/whiteList/factorBase/index.vue')
    },
    {
      path: '/whiteList/infoCollector/created',
      name: 'WhiteListInfoCollectorCreated',
      meta: { showNav: false, title: '信息收集器-信息库-创建' },
      component: () => import('@/views/whiteList/infoCollector/Created.vue')
    },
    {
      path: '/whiteList/gptLab/eventBack',
      name: 'WhiteListGptLabEventBack',
      meta: { showNav: false, title: '公式问答' },
      component: () => import('@/views/whiteList/gptLab/EventBack.vue')
    },
    {
      path: '/whiteList/weChatMsgReply/inclusionIndex',
      name: 'WhiteListInclusionIndex',
      meta: { showNav: false, title: '公式问答', keepAlive: true },
      component: () => import('@/views/whiteList/weChatMsgReply/InclusionIndex/index.vue')
    },
    {
      path: '/whiteList/weChatMsgReply/InclusionIndexDetail',
      name: 'WhiteListInclusionIndexDetail',
      meta: { showNav: false, title: '因子列表' },
      component: () => import('@/views/whiteList/weChatMsgReply/InclusionIndexDetail.vue')
    },
    {
      path: '/whiteList/weChatMsgReply/searchInfoFlow',
      name: 'WhiteListSearchInfoFlow',
      meta: { showNav: false, title: '搜一搜' },
      component: () => import('@/views/whiteList/weChatMsgReply/SearchInfoFlow.vue')
    },
    {
      path: '/whiteList/weChatMsgReply/signalTracking',
      name: 'WhiteListSignalTracking',
      meta: { showNav: false, title: '信号追踪' },
      component: () => import('@/views/whiteList/weChatMsgReply/SignalTracking/index.vue')
    },
    {
      path: '/whiteList/infoCollector/detail',
      name: 'WhiteListInfoCollectorDetail',
      meta: { showNav: false, title: '信息收集器-信息库-详情' },
      component: () => import('@/views/whiteList/infoCollector/Detail.vue')
    },
    {
      path: '/whiteList/weChat/infoAssistant',
      name: 'WeChatInfoAssistant',
      meta: { showNav: false, title: '观照小报' },
      component: () => import('@/views/whiteList/weChat/InfoAssistant.vue')
    },
    {
      path: '/whiteList/ratingStatistics/index',
      name: 'WhiteListRatingStatisticsIndex',
      meta: { showNav: false, title: '评级统计' },
      component: () => import('@/views/whiteList/ratingStatistics/index.vue')
    },
    {
      path: '/whiteList/ratingStatistics/source',
      name: 'WhiteListRatingStatisticsSource',
      meta: { showNav: false, title: '评级统计' },
      component: () => import('@/views/whiteList/ratingStatistics/Source.vue')
    },
    {
      path: '/whiteList/ratingStatistics/asset',
      name: 'WhiteListRatingStatisticsAsset',
      meta: { showNav: false, title: '评级统计' },
      component: () => import('@/views/whiteList/ratingStatistics/Asset.vue')
    },
    {
      path: '/whiteList/qaCurve',
      name: 'WhiteListQaCurve',
      meta: { showNav: false, title: '问答页' },
      component: () => import('@/views/whiteList/qa-curve/index.vue')
    },
    {
      path: '/whiteList/submitFeedback',
      name: 'SubmitFeedback',
      meta: { showNav: false, title: '反馈' },
      component: () => import('@/views/whiteList/SubmitFeedback.vue')
    }
  ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // console.log(to.path, from.path)
  // console.log(to.path, from.path)

  // 设置 title
  if (to.meta.title) {
    document.title = to.meta.title
  }

  NProgress.start() // 开始加载进度条

  // 将上一个路由保存在全局状态中
  Vue.prototype.$previousRoute = from

  let token = localStorage.getItem('Authorization')
  // 根据登录状态判断用户是否已登录
  const isAuthenticated = token && token !== null && token !== ''
  const isLoginPage = to.path === '/login'
  const isInfoCollectorFromH5 = to.path.startsWith('/infoCollector') && to.query && to.query.fromPage === 'h5' // 移动端跳转至信息收集器页面
  const whiteListRoutes = ['/whiteList'] // 白名单路由

  // 如果用户已登录且访问的是登录页，则重定向到其他页面
  if (isAuthenticated && isLoginPage) {
    next('/')
  } else if (!isAuthenticated && !isLoginPage && !whiteListRoutes.some(route => to.path.startsWith(route)) && !isInfoCollectorFromH5) {
    // 如果用户未登录且访问的不是登录页和白名单页，则重定向到登录页
    next({
      path: '/login',
      query: to.query
    })
  } else {
    // 其他情况下正常跳转
    next()
  }
})

router.afterEach(() => {
  NProgress.done() // 结束进度条
})

router.onError(error => {
  console.error('路由导航错误:', error)
  NProgress.done()
  // 可以选择中断导航或者重定向到错误页面
  Dialog.alert({
    title: '提醒',
    message: '检测到页面异常，请尝试刷新页面',
    confirmButtonText: '刷新页面'
  })
    .then(() => {
      window.location.reload()
    })
    .catch(() => {})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js